import { LOCALES } from 'root-constants'

export const enum StripeErrorCode {
  CARD_DECLINED = 'card_declined',
}

export const enum PaymentErrors {
  PAYMENT_INTENT_AUTH_FAILURE = 'payment_intent_authentication_failure',
  INSUFFICIENT_FUNDS = 'card_declined:insufficient_funds',
  DO_NOT_HONOR = 'card_declined:do_not_honor',
  TRANSACTION_NOT_ALLOWED = 'card_declined:transaction_not_allowed',
  TRY_AGAIN_LATER = 'card_declined:try_again_later',
  GENERIC_DECLINE = 'card_declined:generic_decline',
  CARD_VELOCITY_EXCEEDED = 'card_declined:card_velocity_exceeded',
  INVALID_ACCOUNT = 'card_declined:invalid_account',
  PROCESSING_ERROR = 'processing_error',
  FRAUDULENT = 'card_declined:fraudulent',
  LOST_CARD = 'card_declined:lost_card',
  CARD_DECLINED = 'card_declined',
  INCOMPLETE_EXPIRY = 'incomplete_expiry',
  PICKUP_CARD = 'card_declined:pickup_card',
  INVALID_AMOUNT = 'card_declined:invalid_amount',
  SOMETHING_WENT_WRONG = 'something_went_wrong',
  INCORRECT_CVC = 'incorrect_cvc',
  EXPIRED_CARD = 'expired_card',
}

export const PAYMENT_ERROR_MAP = {
  [PaymentErrors.PAYMENT_INTENT_AUTH_FAILURE]:
    'Authentication failed. Please try again or use a different card.',
  [PaymentErrors.INSUFFICIENT_FUNDS]:
    'Not enough funds. Please use another card or add money to your account.',
  [PaymentErrors.DO_NOT_HONOR]:
    'Your bank declined the payment. Please contact your bank or try again.',
  [PaymentErrors.TRANSACTION_NOT_ALLOWED]:
    'This transaction isn’t allowed by your bank. Please try another card or contact your bank.',
  [PaymentErrors.TRY_AGAIN_LATER]:
    'Payment couldn’t go through right now. Please try again or use another card.',
  [PaymentErrors.GENERIC_DECLINE]:
    'The bank declined the payment. Please try again or use another card.',
  [PaymentErrors.CARD_VELOCITY_EXCEEDED]:
    'Too many recent attempts. Please wait a bit or use another card.',
  [PaymentErrors.INVALID_ACCOUNT]:
    'Invalid account. Please check your details or use another card.',
  [PaymentErrors.PROCESSING_ERROR]:
    'Something went wrong while processing. Please check your connection and try again.',
  [PaymentErrors.FRAUDULENT]:
    'The card was declined for an unknown reason. Please try another card.',
  [PaymentErrors.LOST_CARD]:
    'The card was declined for an unknown reason. Please try another card.',
  [PaymentErrors.CARD_DECLINED]:
    'The bank declined the payment. Please try another card.',
  [PaymentErrors.INCOMPLETE_EXPIRY]:
    'Expiry date is missing or incomplete. Please re-enter it.',
  [PaymentErrors.PICKUP_CARD]:
    'The card can’t be used. Please check your card details and try again.',
  [PaymentErrors.INVALID_AMOUNT]:
    'Invalid payment amount. Please try again or contact support.',
  [PaymentErrors.SOMETHING_WENT_WRONG]:
    'Something went wrong. Please check your card details and try again.',
  [PaymentErrors.INCORRECT_CVC]:
    'The CVC code is incorrect. Please re-enter it.',
  [PaymentErrors.EXPIRED_CARD]:
    'Your card has expired. Please use another card.',
}

export const enum PaymentMethod {
  CREDIT_CARD = 'card',
  APPLE_PAY = 'apple_pay',
  GOOGLE_PAY = 'google_pay',
  PAYPAL = 'pay_pal',
  LINK = 'link',
  FAST_PAYMENT = 'fast_payment',
}

export type TPaymentRequestButtons = {
  applePay: boolean
  googlePay: boolean
}

export type TPaymentOptions = {
  paymentRequest: PaymentRequest
  paymentRequestButton: TPaymentRequestButtons
}

export const enum PaymentStatus {
  SUCCESS = 'success',
}

export const enum PaymentSystem {
  PAYPAL = 'paypal',
  STRIPE = 'stripe',
  STRIPE_CS = 'stripe-cs',
  STRIPE_PAYPAL = 'stripe-paypal',
}

export const NOT_UPSELL_LOCALIZATIONS = [
  LOCALES.IT,
  LOCALES.PL,
  LOCALES.JP,
  LOCALES.KR,
  LOCALES.TR,
  LOCALES.RO,
]

export const PIT_PAT_UPSELL_FLOW_KEYS = ['pitpat_50', 'pitpat_25']
